<div class="financial">
  <div class="tabs" role="tablist" aria-label="Financial views">
    <button type="button" role="tab" [class.active]="tab === 'sales'" [attr.aria-selected]="tab === 'sales'" (click)="selectTab('sales')">Sales Invoices</button>
    <button type="button" role="tab" [class.active]="tab === 'disbursements'" [attr.aria-selected]="tab === 'disbursements'" (click)="selectTab('disbursements')">Disbursements</button>
  </div>

  <ng-container *ngIf="tab === 'sales'">
    <app-saved-search
      class="saved-views"
      #savedSearch
      [gridApi]="gridApi"
      [viewFilterType]="viewFilterType"
      [module]="module"
      [pinnedColumns]="pinnedColumns"
      (onClearFilters)="clearFiltersExternally()"
    ></app-saved-search>

    <div class="toolbar">
      <div class="toolbar-left">
        <form class="search" (submit)="$event.preventDefault(); onSearch(searchInput.value)">
          <div class="search-field">
            <span class="search-icon">
              <img src="assets/icons/data-table/search.svg" alt="" width="16" height="16" />
            </span>
            <input
              #searchInput
              type="search"
              [value]="searchText"
              [class.has-clear]="searchDraft"
              placeholder="Search by description..."
              aria-label="Search by description"
              (input)="searchDraft = searchInput.value"
            />
            <button *ngIf="searchDraft" type="button" class="clear-btn clear-btn--search" aria-label="Clear search" (click)="clearSearch(searchInput)">
              <i class="bi bi-x-lg" aria-hidden="true"></i>
            </button>
          </div>
          <button type="submit" class="btn-orange btn-orange--search">Search</button>
        </form>

        <div class="date-filter" ngbDropdown #dateDrop="ngbDropdown" autoClose="outside" display="static" (openChange)="$event && datePicker.revertToValue()">
          <button type="button" class="date-filter-btn" [class.has-clear]="hasDateFilter" ngbDropdownToggle>
            <span>{{ dateLabel }}</span>
            <img src="assets/icons/data-table/calendar.svg" alt="" width="18" height="18" />
          </button>
          <button *ngIf="hasDateFilter" type="button" class="clear-btn clear-btn--date" aria-label="Clear date filter" (click)="onDateCleared()">
            <i class="bi bi-x-lg" aria-hidden="true"></i>
          </button>
          <div class="dropdown-menu date-filter-menu" ngbDropdownMenu>
            <app-date-picker
              #datePicker
              mode="single"
              [range]="true"
              [value]="selectedRange"
              (apply)="onDateApplied($event); dateDrop.close()"
              (clear)="onDateCleared(); dateDrop.close()"
            ></app-date-picker>
          </div>
        </div>

        <div class="date-filter status-filter" ngbDropdown autoClose="outside" display="static">
          <button type="button" class="date-filter-btn" [class.has-clear]="statusSelected.length" ngbDropdownToggle aria-label="Status">
            <span class="status-label">
              <img src="assets/icons/data-table/filter.svg" alt="" width="16" height="16" />
              {{ statusLabel }}
            </span>
            <img class="chevron" src="assets/icons/data-table/chevron.svg" alt="" width="10" height="6" />
          </button>
          <button *ngIf="statusSelected.length" type="button" class="clear-btn clear-btn--status" aria-label="Clear status filter" (click)="clearStatuses()">
            <i class="bi bi-x-lg" aria-hidden="true"></i>
          </button>
          <div class="dropdown-menu status-menu" ngbDropdownMenu>
            <label *ngFor="let option of statusOptions" class="status-option">
              <input type="checkbox" [checked]="statusSelected.includes(option.value)" (change)="toggleStatus(option.value)" />
              {{ option.label }}
            </label>
          </div>
        </div>
      </div>

      <div class="toolbar-right">
        <!-- TODO: Send to Xero stays disabled until its endpoint exists; no endpoint is called. -->
        <button type="button" class="btn-orange" [disabled]="exporting" [attr.aria-busy]="exporting" title="Export Report to CSV" (click)="exportCsv()">
          Export CSV
          <span *ngIf="exporting" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
          <img *ngIf="!exporting" src="assets/icons/data-table/download.svg" alt="" width="16" height="16" />
        </button>
        <button type="button" class="btn-orange" disabled title="Not available yet">
          Send to Xero
          <img src="assets/icons/data-table/download.svg" alt="" width="16" height="16" />
        </button>
      </div>
    </div>

    <ag-grid-angular
      tkGrid
      class="financial-grid"
      style="height: 600px; width: 100%"
      [gridOptions]="gridOptions"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [appSavedSearchSync]="savedSearch"
      (gridReady)="onGridReady($event)"
      (paginationChanged)="onPaginationChanged()"
      (filterChanged)="onFilterChanged()"
    ></ag-grid-angular>
  </ng-container>

  <!-- Mounted only while this tab is open, so the payouts are fetched when it is first opened. -->
  <app-disbursements *ngIf="tab === 'disbursements'"></app-disbursements>
</div>
